import React from "react";
import NewNav from "../components/NewNav";
import styled from "styled-components";
import PaymentStatus from "../components/PaymentStatus";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const ContentWrapper = styled.div`
  flex-grow: 1;
  margin-top: 30px;
`;

const FooterWrapper = styled.footer`
  text-align: center;
  border-top: 1px solid #dadada;
  margin: 100px 70px 10px;
  padding: 30px;
`;

const PaymentStatusPage = () => {
  return (
    <Wrapper>
      <NewNav />
      <ContentWrapper>
        <PaymentStatus />
      </ContentWrapper>
      <FooterWrapper>
        &copy; {new Date().getFullYear()} - Masterbranch Pte Ltd. All rights reserved.
      </FooterWrapper>
    </Wrapper>
  );
};

export default PaymentStatusPage;
